/**
 * Copyright 2026 Salesforce, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Critical Space NK Jost weights for `root.tsx` preload links.
 * Use absolute `/fonts/...` imports (upstream pattern) so Vitest's asset alias
 * can mock them — `@fonts/...?url` resolves to a Vite 7 "Denied ID" in CI.
 */
import jostLatin500 from '/fonts/jost-latin-500-normal.woff2';
import jostLatin600 from '/fonts/jost-latin-600-normal.woff2';

/** Primary UI weight (medium). */
export const primaryFont = jostLatin500;

/** Semibold weight preloaded alongside medium. */
export const primaryFontSemibold = jostLatin600;
